import React, { useEffect, useState } from 'react'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import MetricsSection from './components/MetricsSection'
import InsightsPanel from './components/InsightsPanel'
import { SingleSeriesChart } from './components/SeriesChart'
import { getAnalyticsErrorMessage } from './utils'

const Users = () => {
    const { rangeFilters } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const response = await AnalyticsService.getUsers(rangeFilters)
                if (!cancelled) setData(response)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [rangeFilters])

    return (
        <AnalyticsPageShell title='Análises de negócio — Usuários' loading={loading} error={error} showWorkshopId>
            <MetricsSection
                title='Métricas (estado atual + registros no período — observe o selo)'
                metrics={data?.metrics}
            />
            <SingleSeriesChart
                title='Registros ao longo do tempo (eventos)'
                points={data?.registrationsOverTime}
                dataKey='registros'
            />
            <InsightsPanel insights={data?.insights} />
        </AnalyticsPageShell>
    )
}

export default Users
